







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ImageSourceSet, ResizableImage } from '../types';

interface HTMLSourceSetItem {
  url: string;
  width?: string;
}

interface HTMLSourceSet {
  items: HTMLSourceSetItem[];
  format?: string;
  id: string;
}

@Component
export default class OptimisedImage extends Vue {
  @Prop({ required: true })
  private readonly src!: string | ImageSourceSet;

  @Prop()
  private readonly lazy!: boolean;

  get isBasic() {
    return typeof this.src === 'string';
  }

  get imgSrc(): string {
    if (typeof this.src !== 'object') return this.src;

    if(typeof this.src.source !== 'object') return `${this.src.source}.${this.src.fallback}`;

    return `${this.src.source.Preview.Url}.${this.src.fallback}`;
  }

  get sourceSets(): HTMLSourceSet[] {
    if (typeof this.src !== 'object') return [];

    const source = this.src as ImageSourceSet;

    const sets: HTMLSourceSet[] = [];

    source.formats.forEach((fmt) => {
      sets.push(this.addSourceSet(fmt, source.source));
    });

    return sets;
  }

  addSourceSet(format: string, source: string | ResizableImage): HTMLSourceSet {
    const htmlSourceSet: HTMLSourceSet = {
      items: [],
      format: `image/${format}`,
      id: format
    };

    if (typeof source === 'object') {
      const src = source as ResizableImage;

      if (src.Thumbs.Url !== null) htmlSourceSet.items.push({ url: `${src.Thumbs.Url}.${format}`, width: '300w' });
      if (src.Preview.Url !== null) htmlSourceSet.items.push({ url: `${src.Preview.Url}.${format}`, width: '1200w' });
    } else if (typeof source === 'string') {
      htmlSourceSet.items.push({ url: `${source}.${format}` });
    }

    return htmlSourceSet;
  }
}
